import { render, staticRenderFns } from "./CertificationActionMenu.vue?vue&type=template&id=199609e8&scoped=true&"
import script from "./CertificationActionMenu.vue?vue&type=script&lang=js&"
export * from "./CertificationActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199609e8",
  null
  
)

export default component.exports